// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"5a4a520b","513":"5a93998b"}[chunkId] + ".chunk.js";
};